import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@environments/environment';
import { ApiResponse } from '@app/_models';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class EndpointService {

  constructor(private http: HttpClient) { }

  getEndpointList(searchParams: any) {
    return this.http.post<any>(`${environment.apiUrl}endPoints/list`, searchParams);
  }

  getEndpointById(id: number) {
    return this.http.get<any>(`${environment.apiUrl}endPoints/${id}`);
  }

  save(data: any, forceCreate?: boolean) {
    const url = forceCreate ? 'endPoints?forceCreate=' + forceCreate : 'endPoints';
    return this.http.post<any>(environment.apiUrl + url, data);
  }

  update(data: any) {
    return this.http.put<any>(`${environment.apiUrl}endPoints?forceUpdate=true`, data);
  }

  getEnv(id: number, projectId: number): Observable<ApiResponse> {
    return this.http.get<ApiResponse>(`${environment.apiUrl}endPoints/environments/${id}/${projectId}`);
  }

  getActiveEnv(id: number): Observable<ApiResponse> {
    return this.http.get<ApiResponse>(`${environment.apiUrl}environments/idNamePair/endPoints/${id}`);
  }

  updateEnv(id: number, obj: object): Observable<ApiResponse> {
    return this.http.put<ApiResponse>(`${environment.apiUrl}endPoints/environments/${id}`, obj);
  }

  getSecretTestDataByProject(projectId: number) {
    return this.http.get<any>(`${environment.apiUrl}secretFields/projects/${projectId}`);
  }

  getFilesByProject(projectId: number) {
    return this.http.get<any>(`${environment.apiUrl}file/${projectId}`);
  }

  deleteMultipleEndpoints(entityType: string,entityIdList: number[]): Observable<any> {
    const options = {
      body: {
        entityType,
        entityIdList
      }
    };
     return this.http.delete<any>(`${environment.apiUrl}endPoints/bulkDelete`, options);
  }

  getWebInstructions(id: string | number) {
    return this.http.get<any>(`${environment.apiUrl}webInstructions/endPoints/${id}`);
  }
  getPlaywrightWebInstructions(id: string | number) {
    return this.http.get<any>(`${environment.apiUrl}pwWebInstructions/endPoints/${id}`);
  }

  executeStart(endpointId, params) {
    return this.http.post<any>(`${environment.apiUrl}executors/endPoints/${endpointId}`, params);
  }

  executeWithEnv(endpointId, envId, params) {
    return this.http.post<any>(`${environment.apiUrl}executors/endPoints/${endpointId}/environments/${envId}`, params);
  }

  mostRecentExecuted(id: string | number) {
    return this.http.get<any>(`${environment.apiUrl}result/endPoints/sqlId/${id}/lastExecution`);
  }

  getExecutionResult(noSqlId: string) {
    return this.http.get<any>(`${environment.apiUrl}result/endPoints/executions/${noSqlId}`);
  }

  stopCurrentExecService(noSqlId: any): Observable<any> {
    return this.http.put<any>(`${environment.apiUrl}result/executions/${noSqlId}/stop`, noSqlId);
  }

  getAssociatedTestcases(endpointId: number, requestParams: any) {
    return this.http.post<any>(`${environment.apiUrl}endPoints/${endpointId}/testCases`, requestParams);
  }

  getResDomExtra(noSqlId: string): Observable<any> {
    return this.http.get<any>(`${environment.apiUrl}domExtractors/webInstructions/${noSqlId}`);
  }

  importDomExtractor(endpointId: number , id: number, data: object): Observable<any> {
    return this.http.post<any>(`${environment.apiUrl}webInstructions/importBulkDomExtractor/${endpointId}/${id}`, data);
  }

  updateJsonExtractor(endPoint: object, updateToTestCase: boolean): Observable<any> {
    return this.http.post<any>(`${environment.apiUrl}endPoints/update/extractors?updateToTestCase=${updateToTestCase}`, endPoint);
  }
  saveSecData(formData, id: number, obj) {
    return this.http.post<any>(`${environment.apiUrl}testInputs/endPoints/${id}`, formData, { params: obj });
  }

  validateJs(formData, testCaseId?: any, testCaseEndPointId?: any) {
    if(testCaseId && testCaseEndPointId){
      return this.http.post<any>(`${environment.apiUrl}testInputs/custom/execute?testCaseId=${testCaseId}&testCaseEndPointId=${testCaseEndPointId}`, formData);
    }
    return this.http.post<any>(`${environment.apiUrl}testInputs/custom/execute`, formData);
  }

  validateJsEndpointData(formData, endPointId?: any) {
    return this.http.post<any>(`${environment.apiUrl}testInputs/custom/execute?endPointId=${endPointId}`, formData);
  }

  validateJsTestCaseData(formData, testCaseId?: any, testCaseEndPointId?: any) {
    return this.http.post<any>(`${environment.apiUrl}testInputs/custom/execute?testCaseId=${testCaseId}&testCaseEndPointId=${testCaseEndPointId}`, formData);
  }

  updateSequence(endPointId: number, webInstructions: any) {
    return this.http.put<any>(`${environment.apiUrl}webInstructions/sequence/update/endPoints/${endPointId}`, webInstructions);
  }
  updatePwSequence(endPointId: number, webInstructions: any) {
    return this.http.put<any>(`${environment.apiUrl}pwWebInstructions/endPoints/${endPointId}/sequence`, webInstructions);
  }

  createWebInstruction(endPointId: number, webInstruction: any) {
    return this.http.post<any>(`${environment.apiUrl}webInstructions/endPoints/${endPointId}`, webInstruction);
  }

  webRecordCapture(endPointId: number, url: string, environmentId?: number) {
    let baseUrl = `${environment.apiUrl}web/recorder?endPointId=${endPointId}&url=${encodeURIComponent(url)}`;
    if (environmentId) {
      baseUrl += `&environmentId=${environmentId}`;
    }
    return this.http.get<any>(baseUrl);
    //return this.http.get<any>(`http://10.193.144.136:8083/relay-executor-playwright/web/recorder?endPointId=${endPointId}`);
  }
  webRecordGenerate(name: string, url: string, testcaseId: number, environmentId: number) {
    return this.http.get<any>(`${environment.apiUrl}web/recorder/testCaseWebFlow?endPointName=${name}&endPointUri=${url}&testCaseId=${testcaseId}&environmentId=${environmentId}`);
    //return this.http.get<any>(`http://10.193.144.136:8083/relay-executor-playwright/web/recorder?endPointName=${name}&url=${url}&testcaseId=${testcaseId}`);
  }
  stopWebRecorder(entityId: number) {
    return this.http.get<any>(`${environment.apiUrl}web/recorder/stopRecoding?entityId=${entityId}`);
    // return this.http.get<any>(`http://10.193.144.136:8083/relay-executor-playwright/web/recorder/stopRecording?endPointId=${endPointId}&sessionId=${recordSessionId}`);
  }
  createPwWebInstruction(endPointId: number, webInstruction: any) {
    return this.http.post<any>(`${environment.apiUrl}pwWebInstructions/endPoints/${endPointId}`, webInstruction);
  }

  updateWebInstruction(endPointId: number, webInstruction: any) {
    return this.http.put<any>(`${environment.apiUrl}webInstructions/endPoints/${endPointId}`, webInstruction);
  }
  updateWebInstructionPw(endPointId: number, webInstruction: any) {
    return this.http.put<any>(`${environment.apiUrl}pwWebInstructions/endPoints/${endPointId}`, webInstruction);
  }
  getWebActions() {
    return this.http.get<any>(`${environment.apiUrl}pwWebInstructions/webActions`);
  }
  deleteWebInstruction(webInstructionId: number) {
    return this.http.delete<any>(`${environment.apiUrl}webInstructions/${webInstructionId}`);
  }
  deletePwWebInstruction(webInstructionId: number) {
    return this.http.delete<any>(`${environment.apiUrl}pwWebInstructions/${webInstructionId}`);
  }

  getWebLocators() {
    return this.http.get<any>(`${environment.apiUrl}webLocators`);
  }
  getPwWebLocatortype() {
    return this.http.get<any>(`${environment.apiUrl}pwWebLocators/locatorTypes`);
  }
  getPwComponentType() {
    return this.http.get<any>(`${environment.apiUrl}pwWebLocators/componentTypes`);
  }

  getWebLocatorsList(searchParams) {
    return this.http.post<any>(`${environment.apiUrl}webLocators/list`, searchParams);
  }
  getPwWebLocatorsList(searchParams) {
    return this.http.post<any>(`${environment.apiUrl}pwWebLocators/list`, searchParams);
  }

  getTrendData(id: string, count: number): Observable<any> {
    return this.http.get<any>(`${environment.apiUrl}result/endPoints/apiTrend/${id}?count=${count}`);
  }

  assocDissocBrowserExtensions(id, formData) {
    return this.http.put<any>(`${environment.apiUrl}endPoints/${id}/browserExtensionAssociationDisassociation`, formData);
  }

  getBrowserExtensions(id) {
    return this.http.get<any>(`${environment.apiUrl}projects/${id}/browserExtensions`);
  }
  getProjectWebConfig(id) {
    return this.http.get<any>(`${environment.apiUrl}project/config/webConfig/projects/${id}`);
  }
  getPlaywrightBrowser(browsersTool) {
    return this.http.get<any>(`${environment.apiUrl}executorUtility/browsers/webAutomationTools/${browsersTool}`);
  }
  getAssociatedBrowserExtensions(id) {
    return this.http.get<any>(`${environment.apiUrl}endPoints/${id}/browserExtensions`);
  }

  uploadFile(files: Array<any>, endPointId: string): Observable<any> {
    const formData = new FormData();
    files.forEach((file, index) => {
      formData.append('file' + index, file);
    });
    return this.http.post<any>(`${environment.apiUrl}sapRfc/upload/endPointId/${endPointId}/bulk/testData/`, formData);
  }

  exportAsCurl(endPointId) {
    return this.http.get<any>(`${environment.apiUrl}endPoints/generateCurlCommand/${endPointId}`);
  }

  importCurl(newCURLCommand) {
    return this.http.post<any>(`${environment.apiUrl}endPoints/generateEndPointFromCurlCommand`, newCURLCommand);
  }

  getWebEndpointsByProjectsAndEndpointType(endPointType, projectIds) {
    return this.http.post<any>(`${environment.apiUrl}endPoints/shortData/byProjects?endPointType=${endPointType}`, projectIds);
  }

  createIterableWebInstruction(endPointId: number, webInstruction: any) {
    return this.http.post<any>(environment.apiUrl + 'webInstructions/endPoints/referenceData/' + endPointId, webInstruction);
  }

  updateIterableWebInstruction(endPointId: number, webInstruction: any) {
    return this.http.put<any>(environment.apiUrl + 'webInstructions/endPoints/referenceData/' + endPointId, webInstruction);
  }

  getWebLocatorsByAction(action, projectId){
    return this.http.get<any>(`${environment.apiUrl}webLocators/webAction/${action}?projectId=${projectId}`);
  }
  getPwWebLocatorsByAction(action, projectId){
    return this.http.get<any>(`${environment.apiUrl}pwWebLocators/webAction/${action}?projectId=${projectId}`);
  }

  getLocatorsByKeyword(keyword){
    return this.http.get<any>(`${environment.apiUrl}webLocators/searchKeyword?searchKeyword=${keyword}`);
  }
  getControlKeys(){
    return this.http.get<any>(`${environment.apiUrl}webInstructions/keyboard/keys`);
  }
  getPwLocatorsByKeyword(keyword){
    return this.http.get<any>(`${environment.apiUrl}pwWebLocators/searchKeyword?searchKeyword=${keyword}`);
  }
  getPwinputScope(){
    return this.http.get<any>(`${environment.apiUrl}pwWebInstructions/testInputScopes`);
  }
  getPwKeyboardKeys(){
    return this.http.get<any>(`${environment.apiUrl}pwWebInstructions/keyboardEvents`);
  }
  getPwImageSelectors(){
    return this.http.get<any>(`${environment.apiUrl}pwWebInstructions/imageSelectors`);
  }
  getPwImageCorners(){
    return this.http.get<any>(`${environment.apiUrl}pwWebInstructions/imageCorners`);
  }
  getWeblocatorById(id) {
    return this.http.get<any>(`${environment.apiUrl}webLocators/${id}`);
  }
  saveBulkPwWebinstructions(obj: any): Observable<any> {
    return this.http.put<ApiResponse>(`${environment.apiUrl}pwWebInstructions/updateInBulk`, obj);
  }
  saveBulkWebinstructions(obj: any): Observable<any> {
    return this.http.put<ApiResponse>(`${environment.apiUrl}webInstructions/updateInBulk`, obj);
  }
  lazyLoadResponseBody(nosqlId) {
    return this.http.get<any>(`${environment.apiUrl}result/endPoints/endPointExecution/${nosqlId}`);
  }
  getEndpointMobilePerformanceGraph(nosqlId) {
    return this.http.get<any>(`${environment.apiUrl}mobilePerformance/endpoint/endPointExecution/${nosqlId}/graph`);
  }
  createPromptAssociation(id :any, data: any) {
    return this.http.post<any>(`${environment.apiUrl}prompt-automation/process?endPointId=${id}`, data);
  }
  getPromptAssociation(endPointId :any) {
    return this.http.get<any>(`${environment.apiUrl}prompt-automation/endpoint/${endPointId}`);
  }
  deleteMultipleWebInstructions(entityType: string, entityIdList: number[]): Observable<any> {
    const options = {
      body: {
        entityType,
        entityIdList
      }
    };
    return this.http.delete<any>(`${environment.apiUrl}webInstructions/bulkDelete`, options);
  }
  deleteMultiplePwWebInstructions(entityType: string, entityIdList: number[]): Observable<any> {
    const options = {
      body: {
        entityType,
        entityIdList
      }
    };
    return this.http.delete<any>(`${environment.apiUrl}pwWebInstructions/bulkDelete`, options);
  }

  getRecordingStatus(entityId: number) {
    return this.http.get<any>(`${environment.apiUrl}web/recorder/recordingStatus/${entityId}`);
  }
}
